import { URLS } from "fire-wind-water";
import { common } from "@/model/common";

export default {
  initWeChatShare(formInfo) {
    var shareUrl = window.location.href.replace("#wechat_redirect", "");
    const shareInfo = {
      title: formInfo.shareTitle ? formInfo.shareTitle : document.title, // 分享标题,
      desc: formInfo.shareDesc ? formInfo.shareDesc : "", // 分享描述
      link: common.weChatId
        ? window.config.weChatOauthUrl +
          "?weChatId=" +
          common.weChatId +
          "&scope=&return_url=" +
          encodeURIComponent(
            URLS.removeSearchParam(shareUrl, "token", "retCode", "puzzleFlag")
          )
        : shareUrl,
      imgUrl: formInfo.sharePic
        ? formInfo.sharePic.replace("http://", "https://")
        : "", // 分享图标
    };
    window.$swxsdk.initWxSdk(
      { tenantId: formInfo.tenantId, weChatId: formInfo.attachWXAccount },
      window.apiUrl
    );
    if (formInfo.canShare == "2") {
      window.$swxsdk.on("hideMenuItems", {
        menuList: [
          "menuItem:share:appMessage",
          "menuItem:share:timeline",
          "menuItem:share:qq",
          "menuItem:share:weiboApp",
          "menuItem:favorite",
          "menuItem:share:facebook",
          "menuItem:share:QZone",
        ],
      });
    }
    window.$swxsdk.on("sharer", shareInfo);
    window.$swxsdk.on("sharer_friends", shareInfo);
  },
};
